/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 31/10/2023
 */

import { Button } from '@mui/material'
import React, { useContext } from 'react'
import styles from "./NavigationButtons.module.css"
import CheckoutContext from '../../Context/CheckoutContext';
import { ArrowBack, ArrowForward } from '@mui/icons-material';

const NavigationButtons = ({ step, disabled }) => {

    const { handleNext, handleBack } = useContext(CheckoutContext);

    return (
        <div className={styles.container}>
            <div className={styles.buttonContainer}>
                <Button
                    className={styles.button}
                    variant='contained'
                    onClick={() => handleBack()}
                >
                    <ArrowBack/>
                    Back
                </Button>
                {step === 3 ?
                null :
                <Button
                    className={styles.button}
                    variant='contained'
                    onClick={() => handleNext()}
                    disabled={disabled}
                >
                    Next
                    <ArrowForward/>
                </Button>}
            </div>
        </div>
    )
}

export default NavigationButtons